import { useContext, useEffect } from "react";
import { IGlobalLayoutProps } from "./GlobalLayout.interface";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import Loading from "../Loading/Loading";
import Navbar from "../Navbar/Navbar";
import Header from "../Header/Header";
import { Outlet, useLocation } from "react-router-dom";
import { LayoutContext } from "../../shared/providers/layout/layout.provider";
import { routes } from "../../shared/router/routes";

function GlobalLayout({ children }: IGlobalLayoutProps) {
    const { isAuthenticated } = useContext(AuthenticationContext);
    const { hasLoading } = useContext(LoadingContext);
    const { header, navbar, main, setTitle } = useContext(LayoutContext);
    const location = useLocation();

    useEffect(() => {
        Object.entries(routes).forEach(([_, { path, name }]: [any, { path: string, name?: string }]) => {
            if (!name) return;

            if (location.pathname === path) {
                setTitle(name);
            }
        });
    }, [location])

    return (
        <>
            {hasLoading && <Loading />}
            {isAuthenticated && (
                <div className="layout">
                    <Navbar layoutRef={navbar} />
                    <Header layoutRef={header} />
                    <main ref={main} className="content d-flex flex-column">
                        <Outlet />
                    </main>
                </div>
            )}
            {!isAuthenticated && (
                <>
                    <Outlet />
                </>
            )}
        </>
    );
}

export default GlobalLayout;
